module.exports = __webpack_public_path__ + "img/0.dc08fbc9.svg";